import React from 'react';
import { User } from 'types/userInfo';
import { Marker } from 'react-leaflet';
import L from 'leaflet';
import personIcon from '../../icons/person-icon.svg';
import UserNameTooltip from '../ToolTips/UserNameTooltip';
import { useMapStore } from 'contexts/RootStore.context';
import { observer } from 'mobx-react';

export const UserMarkers = observer(({ users }: { users: User[] }) => {

  const { filterForm } = useMapStore();

  const customIcon = new L.Icon({
    iconUrl: personIcon,
    iconSize: new L.Point(20, 20),
    iconAnchor: [10, 10], // half of icon size.
    className: 'leaflet-custom-icon',
  });

  return (
    <>
      {users.map((user: User) => {
        const markerLong = user.location.coordinates.longitude;
        const markerLat = user.location.coordinates.latitude;

        return (
          <Marker title={`user-marker-${user.user_id}`} icon={customIcon} position={[markerLat, markerLong]}>
            {filterForm.$.displayUserName.value && <UserNameTooltip user={user} />}
          </Marker>
        )
      })}
    </>
  );
})
